import Dexie from "dexie";
import { db } from "@/firebase/firebaseConfig";
import localStorage from "@/db/secure-dataflow";
import AuthService from "@/services/authService";
import Vue from "vue";

const localDb = localStorage.getInstance();

const COLLECTIONS = {
  ENTERPRISE_ACCOUNT_SETTINGS: "enterprise_account_settings",
  SECURE_DATAFLOW: "secure_dataflow"
};

const DOCUMENTS = {
  CUSTOM_REPORTS_CHANNELS: "custom_reports_channels"
};
const ARRAYS = {
  CHANNEL_IDS: "channel_ids"
};

const DEFAULT_MAP_INFO = {
  zoom_level: null
};

const DEFAULT_SETTINGS = {
  is_display_other_vessels: true,
  on_alert_summary_notification: true,
  on_vessel_auto_tracking: false,
  track_display_interval: 60,
  track_history_interval: 60,
};

class SecureDataflowService {
  async saveVessel(payload) {
    let obj = {
      id: 1,
      vessel_info: payload.vesselInfo,
      maneuvering_origin_id: payload.maneuveringOriginId,
      engine_origin_id: payload.engineOriginId,
      alert_origin_id: payload.alertOriginId
    };
    await localDb.vessel.put(obj);
  }

  async existsVesselInfo() {
    let res = await localDb.vessel.get(2);
    return typeof res !== "undefined";
  }

  async getVessel() {
    return await localDb.vessel.get(1);
  }

  async saveChannelMaster(payload) {
    localDb.channel_master
      .bulkPut(payload.channelMaster)
      .then(() => {
        Vue.$log.info("[SDF][IndexedDB] Channel Master was added successfully");
      })
      .catch(Dexie.BulkError, e => {
        Vue.$log.error(
          "[SDF][IndexedDB] Sme raindrops did not succeed. However, " +
            100000 -
            e.failures.length +
            " Channel Master was added successfully"
        );
      });
  }

  async getChannelInfo(channelId) {
    return await localDb.channel_master.get(channelId);
  }

  async saveChannelData(channelId, payload) {
    // channel一つに対してpoint情報を保存する
    let obj = {
      channel_id: channelId,
      point_data: payload
    };
    await localDb.channels_data.put(obj);
  }

  async getChannelData(channelId) {
    return await localDb.channels_data.get(channelId);
  }

  async bulkSaveChannelData(channelsDataList) {
    await localDb.channels_data.bulkPut(channelsDataList);
  }

  // // bulkGet() は、Dexie 3.0.0〜  (now: 2.0.4)
  // async bulkGetChannelData(channelIds) {
  //   return await localDb.channels_data.bulkGet(channelIds);
  // }

  async clearChannelData() {
    await localDb.channels_data.clear();
  }

  async getCustomChannel() {
    let user = await AuthService.getUser();
    let ref = db
      .collection(COLLECTIONS.ENTERPRISE_ACCOUNT_SETTINGS)
      .doc(user.account_id)
      .collection(COLLECTIONS.SECURE_DATAFLOW)
      .doc(DOCUMENTS.CUSTOM_REPORTS_CHANNELS);

    return ref
      .get()
      .then(doc => {
        if (!doc.exists) {
          return [];
        } else {
          return Object.keys(doc.data()).length ? doc.data().channel_ids : []; // {}検知で空配列を返す
        }
      })
      .catch(err => {
        Vue.$log.error("Error setting document", err);
        return [];
      });
  }

  async setCustomChannel(ids) {
    let user = await AuthService.getUser();

    let data = ids.map(element => {
      return {
        id: element.id,
        kind: element.kind,
        order: element.order
      }
    })
    return db
      .collection(COLLECTIONS.ENTERPRISE_ACCOUNT_SETTINGS)
      .doc(user.account_id)
      .collection(COLLECTIONS.SECURE_DATAFLOW)
      .doc(DOCUMENTS.CUSTOM_REPORTS_CHANNELS)
      .set({ [ARRAYS.CHANNEL_IDS]: data }, { merge: true })
      .catch(err => {
        Vue.$log.error("Error setting document", err);
        return null;
      });
  }

  async clearCustomChannels() {
    await db.custom_channels.clear();
  }

  async saveMap(payload) {
    let obj = {
      map_id: 1,
      zoom_level: payload.zoomLevel,
    };
    await localDb.map.put(obj);
  }

  async getMap() {
    return await localDb.map.get(1) || DEFAULT_MAP_INFO;
  }

  async saveSettings(payload) {
    let obj = {
      setting_id: 1,
      is_display_other_vessels: payload.isDisplayOtherVessels,
      on_alert_summary_notification: payload.onAlertSummaryNotification,
      on_vessel_auto_tracking: payload.onVesselAutoTracking,
      track_display_interval: payload.trackDisplayInterval,
      track_history_interval: payload.trackHistoryInterval,
    };
    await localDb.settings.put(obj);
  }

  async getSettings() {
    return await localDb.settings.get(1) || DEFAULT_SETTINGS;
  }

  async cleanup() {
    await localDb.vessel.clear();
    await localDb.channel_master.clear();
    await localDb.channels_data.clear();
    await localDb.map.clear();
    await localDb.settings.clear();
  }

  async deleteDb() {
    await db.delete();
  }
}

export default new SecureDataflowService();
